export default function calculatePriceToUnlockResults(respondentCount: number) {
    let calculatedPrice = 0;
    if (respondentCount <= 25) {
        calculatedPrice = respondentCount * 200;
    } else if (respondentCount >= 26 && respondentCount <= 50) {
        calculatedPrice = 25 * 200 + (respondentCount - 25) * 150;
    } else if (respondentCount >= 51 && respondentCount <= 100) {
        calculatedPrice = 25 * 200 + 25 * 150 + (respondentCount - 50) * 100;
    } else if (respondentCount >= 101) {
        calculatedPrice =
            25 * 200 + 25 * 150 + 50 * 100 + (respondentCount - 100) * 50;
    }

    return calculatedPrice;
}
